import { MenuItem } from "./menu.types";

export const menuItems3: MenuItem[] = [
  // {
  //   id: 11,
  //   label: "Suppliers",
  //   icon: "las la-car",
  //   permissionId: 6,
  //   allowedRoles: [1], //
  //   subItems: [
  //     {
  //       id: 12,
  //       label: "List supplier",
  //       icon: "las la-minus",
  //       to: "/Suppliers",
  //       permissionId: 6,
  //     },
  //   ],
  // },

  {
    id: 11,
    label: "suppliers",
    icon: "las la-car",
    to: "/Suppliers",
    permissionId: 2,
  },

  {
    id: 266,
    label: "oems",
    icon: "las la-industry",
    to: "/OEMs",
    permissionId: 13,
  },
  {
    id: 267,
    label: "Experts",
    icon: "las la-user-tie",
    to: "/Experts",
    permissionId: 4,
  },
  {
    id: 27,
    label: "notifications",
    icon: "las la-bell",
    to: "/notifications",
    permissionId: 6,
  },
  {
    id: 28,
    label: "User Activity",
    icon: "las la-user-clock",
    permissionId: 4,
    subItems: [
      {
        id: 29,
        label: "History",
        icon: "las la-minus",
        to: "/history-user",
        permissionId: 4,
      },
      {
        id: 30,
        label: "Log connection",
        icon: "las la-minus",
        to: "/Connection",
        permissionId: 4,
      },
    ],
  },

  {
    id: 31,
    label: "Users",
    icon: "las la-user",
    to: "/Users",
    permissionId: 3,
  },
  {
    id: 32,
    label: "Email Dispatch",
    icon: "las la-envelope-open-text",
    to: "/email-dispatch",
    permissionId: 4,
  },
];
